import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c667512c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c667512c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c667512c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c667512c')) {
      api.createRecord('c667512c', component.options)
    } else {
      api.reload('c667512c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c667512c&scoped=true", function () {
      api.rerender('c667512c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operatingPlatform/returnCodePrinting/index.vue"
export default component.exports